import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar, Popover} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, buttonField} from '../../core/redux/form'
import {autocompleteMatcher, displayPrediction, highlightPrediction, addressField} from '../../core/google/places'
import Icon from '../../core/components/Icon'
import TypeaheadInput from '../../core/components/TypeaheadInput'
import LoaderButton from '../../core/components/LoaderButton'
import {ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_UPDATED, loadPatrimony, sendAddComplementaryAddressToPatrimonyCmd, sendRemoveComplementaryAddressFromPatrimonyCmd} from '../actions'
import {AddComplementaryAddressToPatrimonyCmd} from '../models'
import i18n from '../i18n'
import style from './AddRemoveComplementaryAddressFromPatrimonyPopover.less'

class AddRemoveComplementaryAddressFromPatrimonyPopover extends Component {
    static displayName = 'AddRemoveComplementaryAddressFromPatrimonyPopover'

    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    _sendAddCmd() {
        const {dispatch, onHide} = this.props
        const {typeahead} = this.refs
        
        return dispatch(sendAddComplementaryAddressToPatrimonyCmd()).then(() => {
            return dispatch(loadPatrimony())
        }).then(() => {
            typeahead.reset()
        })
    }

    _sendRemoveCmd(event, address) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(sendRemoveComplementaryAddressFromPatrimonyCmd(address.uid)).then(() => {
            return dispatch(loadPatrimony())
        })
    }

    render() {
        const {dispatch, form, cmd, patrimony, onHide, ...others} = this.props

        const addressTypeaheadButton = () => {
            if (cmd && cmd.complementaryAddress) {
                return (
                    <Button
                        {...buttonField(form.complementaryAddress(), null)}>
                        <Icon icon='minus' size='xs' />
                    </Button>
                )
            }
            return (
                <Button>
                    <Icon icon='plus' size='xs' />
                </Button>
            )
        }

        return (
            <Popover
                title={i18n.complementaryAddresses}
                {...others}>
                    <ul className={style.addressGroup}>
                        {patrimony.complementaryAddresses.map((address) => (
                            <li key={address.uid}>
                                <a
                                    href=''
                                    className={style.remove}
                                    onClick={(e) => this._sendRemoveCmd(e, address)}>
                                    <Icon icon='minus' size='xs' />
                                </a>
                                <p>
                                    <span>{address.number}</span>
                                    <span> {address.street}</span>
                                    <span>, {address.zipCode}</span>
                                    <span> {address.city}</span>
                                </p>
                            </li>
                        ))}
                    </ul>
                    <form>
                        <Row>
                            <Col xs={12}>
                                <TypeaheadInput
                                    ref='typeahead'
                                    source={autocompleteMatcher}
                                    display={displayPrediction}
                                    highlight={highlightPrediction}
                                    placeholder={i18n.addAddress}
                                    buttonAfter={addressTypeaheadButton()}
                                    {...addressField(form.complementaryAddress())} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={4} sm={3}>
                                <Input disabled
                                    type='text'
                                    name='number'
                                    placeholder={i18n.addressNumber}
                                    {...form.complementaryAddress.number()} />
                            </Col>
                            <Col xs={8} sm={9}>
                                <Input disabled
                                    type='text'
                                    name='street'
                                    placeholder={i18n.addressStreet}
                                    {...form.complementaryAddress.street()} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={4} sm={3}>
                                <Input disabled
                                    type='text'
                                    name='zipCode'
                                    placeholder={i18n.addressZipCode}
                                    {...form.complementaryAddress.zipCode()} />
                            </Col>
                            <Col xs={8} sm={9}>
                                <Input disabled
                                    type='text'
                                    name='city'
                                    placeholder={i18n.addressCity}
                                    {...form.complementaryAddress.city()} />
                            </Col>
                        </Row>
                    </form>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendAddCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.save}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>

            </Popover>
        )
    }
}

AddRemoveComplementaryAddressFromPatrimonyPopover = connectForm({
    target: 'cmd',
    schema: AddComplementaryAddressToPatrimonyCmd.schema,
    action: ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_UPDATED
})(AddRemoveComplementaryAddressFromPatrimonyPopover)

AddRemoveComplementaryAddressFromPatrimonyPopover = connect((state) => ({
    patrimony: state.patrimony.patrimony,
    cmd: state.patrimony.addComplementaryAddressToPatrimonyCmd
}))(AddRemoveComplementaryAddressFromPatrimonyPopover)

export default AddRemoveComplementaryAddressFromPatrimonyPopover


// WEBPACK FOOTER //
// ./lib/patrimony/components/AddRemoveComplementaryAddressFromPatrimonyPopover.js